import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
  Input
} from '@angular/core'
import { Router } from '@angular/router'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { Actions, ofType } from '@ngrx/effects'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import moment from 'moment-mini'
import {
  BehaviorSubject,
  combineLatest,
  Observable,
  of,
  Subject,
  Subscription
} from 'rxjs'
import {
  catchError,
  distinctUntilChanged,
  filter,
  first,
  map,
  startWith,
  switchMap,
  take,
  timeout,
  withLatestFrom
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { routerSelectors } from 'src/app/core/router/router.selectors'
import { CalendarService } from 'src/app/shared/components/calendar/calendar.service'
import { CalendarEvent } from 'src/app/shared/components/calendar/event'
import { v4 as uuidv4 } from 'uuid'
import { Product } from '../../product/product'
import { productSelectors } from '../../product/product.selectors'
import { Booking, BookingCreationType } from '../booking'
import { bookingActions } from '../booking.actions'
import { bookingSelectors } from '../booking.selectors'
import { BookingMultiCreateDto } from '../multi-create-form/booking-multi-create'
import { participationSelectors } from '../participation/participation.selectors'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
import { environment } from 'src/environments/environment'
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { getTargetDatesFromConfig } from 'src/app/shared/components/date-range-repeat/date-range-transformer'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { BookingSupervisorAssignComponent } from '../supervisor-assign/show.component'
import { BulkAction, SupervisorBookingDto } from 'src/app/shared/interfaces'
import {
  SupervisorBooking,
  SupervisorBookingStatus
} from '../../supervisor-booking/supervisor-booking'
import { SupervisorBookingService } from '../../supervisor-booking/supervisor-booking.service'
import {
  isMemberBusy,
  isMemberBusyAtSupervisor
} from '../supervisorAttach.functions'
import { memberSelectors } from '../../member/member.selectors'
import { Member } from '../../member/member'
import { supervisorBookingActions } from '../../supervisor-booking/supervisor-booking.actions'
import { supervisorBookingSelectors } from '../../supervisor-booking/supervisor-booking.selectors'
import { employeeBookingSelectors } from '../../employee-booking/employee-booking.selectors'
import { EmployeeBooking } from '../../employee-booking/employee-booking'
import { ModalTableUnavailableActionComponent } from '../supervisor-tab/modal-table-unavailable-action/modal-table-unavailable-action.component'
import { BookingReviewTableComponent } from '../booking-review-table/table.component'
import { BookingSeriesModalComponent } from '../booking-series-modal/booking-series-modal..component'
import { RoundMinutesPipe } from 'src/app/shared/pipes/round-minutes.pipe'
import { productActions } from '../../product/product.actions'
import { metaOptionSelectors } from '../../meta-option/meta-option.selectors'
import { MetaOptionKeys } from '../../meta-option/meta-option'
import { getAllDaysNotAvailabilityInYearBuffer } from 'src/app/shared/until'
import { DateRangeRepeatType } from 'src/app/shared/components/date-range-repeat/date-range-repeat'
import { courseSelectors } from '../../course/course.selectors'
import { Moment } from 'moment-mini'
interface SelectedBulActions {
  dateRange: string
  action: any
  startDate: any
  endDate: any
  arraySupervisor: any[]
}
type RichedBooking = Booking & {
  startTargetDate: Moment | string
  endTargetDate: Moment | string
  activity: string
  resource: string
  intersectingBooking: Booking[]
  dependantProductIssue: Product[]
  yearCalendarIssue?: boolean
}
@UntilDestroy()
@Component({
  selector: 'booking-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class BookingCreateComponent
  implements OnInit, OnDestroy
{
  @Input() hideHeaderSections: boolean = false
  @Input() courseId: number
  public showRepeatForm: boolean = false
  public wantApplyYearMatrix: boolean = true
  public calendarEvents$: Observable<CalendarEvent[]>
  public selectedBookableProductIds$: Subject<number[]> = new BehaviorSubject(
    null
  )
  public supervisorAssign: SelectedBulActions = {
    dateRange: null,
    action: null,
    startDate: null,
    endDate: null,
    arraySupervisor: []
  }
  public createdBookings: Booking[] = []
  public showCreatedBookingsModal: boolean = false
  public disabledDates: Date[] = []
  public disabledDatesToApply: Date[] = []
  public bsModalRefTable: BsModalRef
  private supervisorConflicts: any[] = []
  private createSupervisorBooking: boolean = false
  public selectedLinkedProductId$: Subject<number> = new BehaviorSubject(null)
  public selectedAllowedLinkedProductIds$: Subject<number[]> =
    new BehaviorSubject(null)
  public productEntities$: Observable<Dictionary<Product>>
  public activeTab: string = 'bookingType'
  public generalFormSubmitted: boolean = false
  public isRepeat: boolean = false
  public assignSupervisor: boolean = false
  public bookingMultiCreateDto: BookingMultiCreateDto
  public selectedBookingCreateType: BookingCreationType =
    BookingCreationType.DEFAULT
  public BookingCreationType = BookingCreationType
  public bookingPartial: Partial<Booking>
  public selectedDate$: Subject<any> = new BehaviorSubject(null)
  public linkedProductChange$: Observable<Product>
  private subscriptions: Subscription[] = []
  public isLoading$: Observable<boolean>
  public courseProduct$: Observable<Product | null>
  public form: UntypedFormGroup
  public formRepeatConfig: UntypedFormGroup
  public stopLoading: boolean = true
  private selectedAllowedLinkedProductIds: number[] = []
  public resetRepeatForm$: Subject<boolean> = new Subject<boolean>()
  public createBookingFromSchedule: boolean = false
  private lastBookingFetch = {
    productsIds: [],
    startDate: null,
    endDate: null
  }
  private event$: Subject<any> = new BehaviorSubject({
    startDate: moment().startOf('isoWeek').toDate(),
    endDate: moment().endOf('isoWeek').toDate()
  })
  public resetSupervisorBookingsData$: Subject<boolean> = new Subject<boolean>()
  constructor(
    private bsModalRef: BsModalRef,
    private store: Store<AppState>,
    public supervisorBookingService: SupervisorBookingService,
    private actions$: Actions,
    private router: Router,
    private cdref: ChangeDetectorRef,
    private notificationService: NotificationService,
    private calendarService: CalendarService,
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private modalService: BsModalService,
    private roundMinutes: RoundMinutesPipe
  ) {}
  ngOnInit() {
    this.isLoading$ = this.store.select(bookingSelectors.selectIsLoading)
    this.subscriptions.push(
      this.store
        .select(routerSelectors.selectQueryParams)
        .subscribe((queryParams) => {
          if (!this.createBookingFromSchedule) {
            this.activeTab = queryParams?.activeTab ?? 'bookingType'
          }

          if (this.courseId) {
            this.activeTab = 'generalForm'
          }
        })
    )

    this.form = this.fb.group({
      linkedProductId: [null, []],
      productIds: [null, [Validators.required]],
      description: [null, []],
      maxParticipants: [null, [Validators.min(0)]],
      courseId: [null, []],
      startDate: [
        null,
        [Validators.required, Validators.minLength(5), this.dateValidator]
      ],
      endDate: [null, [Validators.required, this.dateValidator]],
      status: [0, [Validators.required]],
      memo: [null, []],
      serieId: [null, []],
      colour: [null, []],
      allowedLinkedProductIds: [null]
    })

    this.formRepeatConfig = this.fb.group({
      repeatType: [DateRangeRepeatType.Weekly, [Validators.required]],
      repeatEvery: [null, [Validators.required, Validators.min(1)]],
      repeatOn: new UntypedFormArray([]),
      repeatOnDay: [null],
      fromDate: [null, [Validators.required]],
      tillDate: [null, [Validators.required]]
    })
    this.productEntities$ = this.store.select(productSelectors.selectEntities)

    this.calendarEvents$ = combineLatest([
      this.store.select(bookingSelectors.selectAll),
      this.selectedAllowedLinkedProductIds$,
      this.selectedLinkedProductId$,
      this.selectedBookableProductIds$,
      this.productEntities$
    ]).pipe(
      map(
        ([
          bookings,
          selectedAllowedLinkedProductIds,
          selectedLinkedProductId,
          selectedBookableProductIds,
          productEntities
        ]) => {
          if (
            !selectedLinkedProductId &&
            (!selectedAllowedLinkedProductIds ||
              selectedAllowedLinkedProductIds?.length == 0) &&
            !selectedBookableProductIds
          ) {
            return []
          }

          let bookingsWithDependantsProduct = []
          let arrayToReturn = []
          let continueSwitch = true
          if (
            (selectedLinkedProductId ||
              selectedAllowedLinkedProductIds?.length > 0) &&
            selectedBookableProductIds &&
            continueSwitch
          ) {
            const bookkingWPotentialAct: Booking[] = bookings.filter(
              (booking) =>
                (booking.linkedProductId === 0 &&
                  booking.allowedLinkedProducts?.length > 0 &&
                  this.isAllowedLinkedProducts(
                    booking,
                    selectedAllowedLinkedProductIds,
                    selectedLinkedProductId,
                    selectedBookableProductIds
                  )) ||
                (booking.linkedProductId === null &&
                  booking.allowedLinkedProducts?.length > 0 &&
                  this.isBookingProductAllowed(
                    booking,
                    selectedLinkedProductId,
                    selectedAllowedLinkedProductIds
                  ))
            )
            const bookkingWSelectedAProduct: Booking[] = bookings.filter(
              (booking) =>
                selectedBookableProductIds.includes(booking.productId)
            )
            continueSwitch = false

            const bookingWithDependantProducts = bookings.filter((booking) => {
              if (
                (booking.productId &&
                  productEntities[booking.productId]?.dependantProducts &&
                  productEntities[booking.productId]?.dependantProducts.filter(
                    (item) => selectedBookableProductIds.includes(item)
                  ).length > 0) ||
                (booking.linkedProductId &&
                  productEntities[booking.linkedProductId]?.dependantProducts &&
                  productEntities[
                    booking.linkedProductId
                  ]?.dependantProducts.filter((item) =>
                    selectedBookableProductIds.includes(item)
                  ).length > 0)
              ) {
                return true
              }
            })
            arrayToReturn = [
              ...new Set([
                ...bookkingWSelectedAProduct,
                ...bookkingWPotentialAct,
                ...bookingWithDependantProducts
              ])
            ]
            arrayToReturn
              .map((booking) => {
                let haveDependant = false
                if (
                  booking.productId &&
                  productEntities[booking.productId]?.dependantProducts
                ) {
                  haveDependant = true
                }
                if (
                  booking.linkedProductId &&
                  productEntities[booking.linkedProductId]?.dependantProducts
                ) {
                  haveDependant = true
                }
                if (haveDependant) {
                  bookingsWithDependantsProduct.push({
                    ...booking,
                    isDependant:
                      productEntities[booking.productId]?.dependantProducts
                        ?.length > 0 ||
                      productEntities[booking.linkedProductId]
                        ?.dependantProducts?.length > 0
                        ? true
                        : false,
                    dependantProducts:
                      productEntities[booking.productId]?.dependantProducts ??
                      productEntities[booking.linkedProductId]
                        ?.dependantProducts
                  })
                }
              })
              .filter((x) => Boolean(x))
              .flat()
          }
          if (
            !selectedLinkedProductId &&
            (!selectedAllowedLinkedProductIds ||
              selectedAllowedLinkedProductIds?.length == 0) &&
            selectedBookableProductIds &&
            continueSwitch
          ) {
            const bookkingWPotentialAct: Booking[] = []
            const bookkingWProductIds: Booking[] = bookings.filter((booking) =>
              selectedBookableProductIds.includes(booking.productId)
            )
            continueSwitch = false
            const bookingWithDependantProducts = bookings.filter((booking) => {
              if (
                (booking.productId &&
                  productEntities[booking.productId]?.dependantProducts &&
                  productEntities[booking.productId]?.dependantProducts.filter(
                    (item) => selectedBookableProductIds.includes(item)
                  ).length > 0) ||
                (booking.linkedProductId &&
                  productEntities[booking.linkedProductId]?.dependantProducts &&
                  productEntities[
                    booking.linkedProductId
                  ]?.dependantProducts.filter((item) =>
                    selectedBookableProductIds.includes(item)
                  ).length > 0)
              ) {
                return true
              }
            })
            arrayToReturn = [
              ...new Set([
                ...bookkingWProductIds,
                ...bookkingWPotentialAct,
                ...bookingWithDependantProducts
              ])
            ]
            arrayToReturn
              .map((booking) => {
                let haveDependant = false
                if (
                  booking.productId &&
                  productEntities[booking.productId]?.dependantProducts
                ) {
                  haveDependant = true
                }
                if (
                  booking.linkedProductId &&
                  productEntities[booking.linkedProductId]?.dependantProducts
                ) {
                  haveDependant = true
                }
                if (haveDependant) {
                  bookingsWithDependantsProduct.push({
                    ...booking,
                    isDependant:
                      productEntities[booking.productId]?.dependantProducts
                        ?.length > 0 ||
                      productEntities[booking.linkedProductId]
                        ?.dependantProducts?.length > 0
                        ? true
                        : false,
                    dependantProducts:
                      productEntities[booking.productId]?.dependantProducts ??
                      productEntities[booking.linkedProductId]
                        ?.dependantProducts
                  })
                }
              })
              .filter((x) => Boolean(x))
              .flat()
          }
          if (
            (selectedLinkedProductId ||
              selectedAllowedLinkedProductIds?.length > 0) &&
            !selectedBookableProductIds &&
            continueSwitch
          ) {
            const bookkingWSelectedLinked: Booking[] = bookings.filter(
              (booking) =>
                booking.linkedProductId === selectedLinkedProductId &&
                booking.linkedProductId !== null
            )
            const bookkingWSelectedAllowedLinked: Booking[] = bookings.filter(
              (booking) =>
                selectedAllowedLinkedProductIds?.includes(
                  booking.linkedProductId
                )
            )
            const bookkingWPotentialAct: Booking[] = bookings.filter(
              (booking) =>
                (booking.linkedProductId === 0 &&
                  booking.allowedLinkedProducts?.length > 0 &&
                  this.isAllowedLinkedProducts(
                    booking,
                    selectedAllowedLinkedProductIds,
                    selectedLinkedProductId,
                    selectedBookableProductIds
                  )) ||
                (booking.linkedProductId === null &&
                  booking.allowedLinkedProducts?.length > 0 &&
                  this.isBookingProductAllowed(
                    booking,
                    selectedLinkedProductId,
                    selectedAllowedLinkedProductIds
                  ))
            )
            continueSwitch = false
            arrayToReturn = [
              ...new Set([
                ...bookkingWSelectedLinked,
                ...bookkingWSelectedAllowedLinked,
                ...bookkingWPotentialAct
              ])
            ]
            arrayToReturn
              .map((booking) => {
                let haveDependant = false
                if (
                  booking.productId &&
                  productEntities[booking.productId]?.dependantProducts
                ) {
                  haveDependant = true
                }
                if (
                  booking.linkedProductId &&
                  productEntities[booking.linkedProductId]?.dependantProducts
                ) {
                  haveDependant = true
                }
                if (haveDependant) {
                  bookingsWithDependantsProduct.push({
                    ...booking,
                    isDependant:
                      productEntities[booking.productId]?.dependantProducts
                        ?.length > 0 ||
                      productEntities[booking.linkedProductId]
                        ?.dependantProducts?.length > 0
                        ? true
                        : false,
                    dependantProducts:
                      productEntities[booking.productId]?.dependantProducts ??
                      productEntities[booking.linkedProductId]
                        ?.dependantProducts
                  })
                }
              })
              .filter((x) => Boolean(x))
              .flat()
          }
          bookingsWithDependantsProduct.forEach((item) => {
            if (!arrayToReturn.find((booking) => item.id != booking.id)) {
              arrayToReturn.push(item)
            }
          })

          return [...arrayToReturn]
        }
      ),
      withLatestFrom(
        this.store.select(productSelectors.selectEntities),
        this.store.select(participationSelectors.selectEntities),
        this.store.select(bookingSelectors.selectAll)
      ),
      map(
        ([
          bookings,
          productEntities,
          participationEntities,
          dependantBookings
        ]) => {
          let richedBookings = JSON.parse(JSON.stringify(bookings))

          return richedBookings.map((booking) => {
            const activityDescription =
              productEntities[booking.linkedProductId]?.description

            const resourceDescription =
              productEntities[booking.productId]?.description

            return this.calendarService.mapBookingToCalEvent(
              booking,
              productEntities[booking.productId],
              productEntities[booking.linkedProductId],
              booking.participations?.map((pId) => participationEntities[pId]),
              activityDescription
                ? `${activityDescription} - `
                : `${resourceDescription}`
            )
          })
        }
      )
    )

    this.form.controls.startDate.valueChanges
      .pipe(
        distinctUntilChanged((prev, curr) => {
          if (!prev && !curr) return true
          if (!prev || !curr) return false
          return moment(prev).isSame(moment(curr), 'minute')
        }),
        untilDestroyed(this)
      )
      .subscribe((data) => {
        this.formRepeatConfig.controls.fromDate.patchValue(data)
      })
    this.form.controls.endDate.valueChanges
      .pipe(
        distinctUntilChanged((prev, curr) => {
          if (!prev && !curr) return true
          if (!prev || !curr) return false
          return moment(prev).isSame(moment(curr), 'minute')
        }),
        untilDestroyed(this)
      )
      .subscribe((data) => {
        this.formRepeatConfig.controls.tillDate.patchValue(data)
      })

    this.linkedProductChange$ = this.selectedLinkedProductId$.pipe(
      distinctUntilChanged((x, y) => x === y),
      switchMap((id) => {
        return this.productEntities$.pipe(
          map((products) => {
            if (id) {
              return products[id]
            }
            return null
          })
        )
      })
    )
    combineLatest([
      this.selectedBookableProductIds$,
      this.selectedLinkedProductId$,
      this.selectedAllowedLinkedProductIds$,
      this.event$
    ])
      .pipe(untilDestroyed(this))
      .subscribe(
        ([
          selectedBookableProductIds,
          selectedLinkedProductId,
          selectedAllowedLinkedProductIds,
          event
        ]) => {
          const totalProductIds = [
            ...new Set([
              selectedLinkedProductId,
              ...(selectedBookableProductIds ?? []),
              ...(selectedAllowedLinkedProductIds ?? [])
            ])
          ].filter(Boolean)
          if (!totalProductIds?.length || totalProductIds?.length == 0) return
          if (
            this.lastBookingFetch.productsIds.length ==
              totalProductIds?.length &&
            this.lastBookingFetch.productsIds.every((it) =>
              totalProductIds.includes(it)
            ) &&
            moment(event?.startDate).format('YYYY-MM-DD') ==
              this.lastBookingFetch.startDate &&
            moment(event?.endDate).format('YYYY-MM-DD') ==
              this.lastBookingFetch.endDate
          )
            return
          this.lastBookingFetch.productsIds = totalProductIds
          this.lastBookingFetch.startDate = moment(event?.startDate).format(
            'YYYY-MM-DD'
          )
          this.lastBookingFetch.endDate = moment(event?.endDate).format(
            'YYYY-MM-DD'
          )
          this.store.dispatch(
            bookingActions.fetchMany({
              params: RequestQueryBuilder.create({
                join: [
                  { field: 'participations' },
                  { field: 'product' },
                  { field: 'linkedProduct' },
                  { field: 'product.dependantProducts' },
                  { field: 'allowedLinkedProducts' },
                  { field: 'course' },
                  { field: 'supervisors' },
                  { field: 'supervisorBookings' }
                ],
                search: {
                  startDate: {
                    [CondOperator.GREATER_THAN_EQUALS]: moment(event?.startDate)
                      .subtract(2, 'hour')
                      ?.toISOString()
                  },
                  endDate: {
                    [CondOperator.LOWER_THAN_EQUALS]: moment(event?.endDate)
                      .add(2, 'hour')
                      ?.toISOString()
                  },
                  $or: [
                    [
                      ...new Set([...(selectedBookableProductIds ?? [])])
                    ].filter(Boolean)?.length
                      ? {
                          productId: {
                            [CondOperator.IN]: selectedBookableProductIds
                          }
                        }
                      : null,

                    [
                      ...new Set([
                        selectedLinkedProductId,

                        ...(selectedAllowedLinkedProductIds ?? [])
                      ])
                    ].filter(Boolean)?.length
                      ? {
                          linkedProductId: {
                            [CondOperator.IN]: [
                              ...new Set([
                                selectedLinkedProductId,

                                ...(selectedAllowedLinkedProductIds ?? [])
                              ])
                            ].filter(Boolean)
                          }
                        }
                      : null,
                    [
                      ...new Set([
                        selectedLinkedProductId,

                        ...(selectedAllowedLinkedProductIds ?? [])
                      ])
                    ].filter(Boolean)?.length
                      ? {
                          'allowedLinkedProducts.id': {
                            [CondOperator.IN]: [
                              ...new Set([
                                selectedLinkedProductId,

                                ...(selectedAllowedLinkedProductIds ?? [])
                              ])
                            ].filter(Boolean)
                          }
                        }
                      : null
                  ].filter((c) => Boolean(c))
                }
              })
            })
          )
        }
      )
    if (this.courseId) {
      this.activeTab = 'generalForm'
      this.selectedBookingCreateType = BookingCreationType.DEFAULT
    }

    this.courseProduct$ = this.store
      .select(courseSelectors.selectEntities)
      .pipe(
        untilDestroyed(this),
        map((courseEntities) => {
          if (this.courseId && courseEntities[this.courseId]?.product) {
            return courseEntities[this.courseId].product
          }
          return null
        }),
        distinctUntilChanged(),
        startWith(null)
      )

    this.store
      .select(metaOptionSelectors.selectAll)
      .pipe(
        withLatestFrom(
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole)
        ),
        untilDestroyed(this)
      )
      .subscribe(([allMetaOptions, userRole]) => {
        const metaOption = allMetaOptions.find(
          (option) =>
            option.key == MetaOptionKeys.DEFAULT_YEAR_MATRIX &&
            option.siteId == userRole?.siteId
        )

        this.disabledDates = []
        this.disabledDatesToApply = []
        this.disabledDates = getAllDaysNotAvailabilityInYearBuffer(
          metaOption?.value ?? null
        )
        this.disabledDatesToApply = JSON.parse(
          JSON.stringify(this.disabledDates)
        )
      })
  }

  public openModalAssignSupervisor(showModal: boolean) {
    this.supervisorConflicts = []
    this.assignSupervisor = showModal
    let bsModalRef: BsModalRef
    if (this.assignSupervisor) {
      bsModalRef = this.modalService.show(BookingSupervisorAssignComponent, {
        initialState: {
          formCreate: this.form.value,
          isRepeat: this.isRepeat,
          showButtonsInsteadBulkActions: true,
          customTitle: 'bookingModule.assignSupervisor',
          showCancelButtonInModalVersion: true
        },
        class: 'modal-lg modal-dialog-scrollable',
        backdrop: 'static'
      })
      bsModalRef.onHide.pipe(take(1)).subscribe((modal) => {
        this.supervisorAssign = bsModalRef.content.supervisorAssign
        if (this.supervisorAssign.arraySupervisor?.length > 0) {
          this.createSupervisorBooking = true
          this.store.dispatch(
            supervisorBookingActions.fetchMany({
              params: RequestQueryBuilder.create({
                search: {
                  personId: {
                    [CondOperator.IN]:
                      this.supervisorAssign.arraySupervisor.map(
                        (item) => item.personId
                      )
                  }
                },
                join: [{ field: 'product' }]
              })
            })
          )

          this.store.dispatch(bookingActions.actionFinishedReset())
          this.store
            .select(bookingSelectors.selectActionFinished)
            .pipe(
              first(
                (actItem) =>
                  actItem !== null &&
                  actItem.action ==
                    bookingActions.createManyWithOneMinuteLess.type
              ),
              withLatestFrom(
                this.store.select(memberSelectors.selectEntities),
                this.store.select(bookingSelectors.selectEntities),
                this.store.select(supervisorBookingSelectors.selectEntities),
                this.store.select(employeeBookingSelectors.selectEntities)
              )
            )
            .subscribe(
              ([
                actItem,
                memberEntities,
                bookingEntities,
                supervisorBookingEntities,
                employeeBookingEntities
              ]) => {
                const {
                  endDate,
                  expiredDate,
                  startDate,
                  startEventDate,
                  ...data
                } = actItem.data

                if (data && this.createSupervisorBooking) {
                  let supervisorBookingDto: SupervisorBookingDto[] = []
                  let bookings = []
                  if (this.supervisorAssign.dateRange) {
                    bookings = Object.values(data)
                    if (this.supervisorAssign.dateRange == 'future') {
                      bookings = Object.values(data)?.filter(
                        (item: any) =>
                          moment(item.startDate).valueOf() >=
                          moment(this.supervisorAssign.startDate).valueOf()
                      )
                    }

                    bookings.forEach((booking) => {
                      supervisorBookingDto = [
                        ...supervisorBookingDto,
                        ...this.createSupervisorBookingNeedsCreate(
                          this.supervisorAssign.action,
                          this.supervisorAssign.arraySupervisor,
                          booking,
                          memberEntities,
                          bookingEntities,
                          supervisorBookingEntities,
                          employeeBookingEntities
                        )
                      ]
                    })
                  } else {
                    Object.values(data)?.forEach((booking: any) => {
                      if (
                        moment(booking.startDate)
                          .set('seconds', 0)
                          .set('milliseconds', 0)
                          .valueOf() >=
                          moment(
                            moment(this.form.controls.startDate.value)
                              .set('seconds', 0)
                              .set('milliseconds', 0)
                              .toISOString()
                          ).valueOf() &&
                        moment(booking.endDate).valueOf() <=
                          moment(
                            moment(
                              this.form.controls.endDate.value
                            ).toISOString()
                          ).valueOf()
                      ) {
                        supervisorBookingDto = [
                          ...supervisorBookingDto,
                          ...this.createSupervisorBookingNeedsCreate(
                            this.supervisorAssign.action,
                            this.supervisorAssign.arraySupervisor,
                            booking,
                            memberEntities,
                            bookingEntities,
                            supervisorBookingEntities,
                            employeeBookingEntities
                          )
                        ]
                      }
                    })
                  }
                  if (
                    !supervisorBookingDto ||
                    supervisorBookingDto?.length == 0
                  ) {
                    this.supervisorAssign = {
                      dateRange: null,
                      action: null,
                      startDate: null,
                      endDate: null,
                      arraySupervisor: []
                    }
                    this.createSupervisorBooking = false
                    if (this.supervisorConflicts.length > 0) {
                      this.bsModalRefTable = this.modalService.show(
                        ModalTableUnavailableActionComponent,
                        {
                          initialState: {
                            bookings: this.supervisorConflicts.map(
                              (item) => item.booking
                            )
                          },
                          class:
                            'modal-xl modal-dialog-scrollable modal-dialog-centered mod-2',
                          backdrop: 'static'
                        }
                      )
                      this.supervisorConflicts = []
                    }
                    return
                  }

                  this.supervisorBookingService
                    .createManySupervisorBooking(
                      supervisorBookingDto.map((item) => {
                        return item
                      })
                    )
                    .pipe(take(1))
                    .subscribe((response: any) => {
                      this.supervisorAssign = {
                        dateRange: null,
                        action: null,
                        startDate: null,
                        endDate: null,
                        arraySupervisor: []
                      }
                      if (response?.conflictBookings?.length > 0) {
                        this.bsModalRefTable = this.modalService.show(
                          ModalTableUnavailableActionComponent,
                          {
                            initialState: {
                              bookings: response?.conflictBookings
                            },
                            class:
                              'modal-xl modal-dialog-scrollable modal-dialog-centered mod-3',
                            backdrop: 'static'
                          }
                        )
                        this.supervisorConflicts = []
                      }
                      this.store.dispatch(
                        supervisorBookingActions.actionFinished({
                          actionFinished: {
                            action: supervisorBookingActions.createMany.type,
                            data: []
                          }
                        })
                      )

                      this.notificationService.emit(
                        `Create supervisors for Bookings ${[
                          ...new Set(
                            supervisorBookingDto.map((item) => item.bookingId)
                          )
                        ]} supervisor Ids:${[
                          ...new Set(
                            supervisorBookingDto.map((item) => item.personId)
                          )
                        ]} , total ${
                          response?.createdSupervisorBookings?.length
                        }`,
                        'info'
                      )
                      this.createSupervisorBooking = false
                    })
                } else {
                  this.createSupervisorBooking = false
                  this.supervisorAssign = {
                    dateRange: null,
                    action: null,
                    startDate: null,
                    endDate: null,
                    arraySupervisor: []
                  }
                }
              }
            )
        } else {
          this.createSupervisorBooking = false
          this.assignSupervisor = false
        }
      })
    } else {
      this.assignSupervisor = false
      this.supervisorAssign = {
        dateRange: null,
        action: null,
        startDate: null,
        endDate: null,
        arraySupervisor: []
      }
      bsModalRef?.hide()
    }
  }
  private createSupervisorBookingNeedsCreate(
    action: any,
    arraySupervisor: any[],
    booking: Booking,
    memberEntities: Dictionary<Member>,
    bookingEntities: Dictionary<Booking>,
    supervisorBookingEntities: Dictionary<SupervisorBooking>,
    employeeBookingEntities: Dictionary<EmployeeBooking>
  ): SupervisorBookingDto[] {
    let supervisorBookingDto: SupervisorBookingDto[] = []
    if (!action) {
      return []
    }
    arraySupervisor.forEach((item) => {
      const daysBusy = memberEntities[item.personId]?.weekCalendar?.filter(
        (days) => !days.isAvailable
      )
      const member = {
        ...memberEntities[item.personId],
        supervisorBookings: Object.values(supervisorBookingEntities)
          .filter((sup) => sup.personId == item.personId)
          .map((superv) => {
            return {
              ...superv,
              startDate: bookingEntities[superv.bookingId]?.startDate ?? null,
              endDate: bookingEntities[superv.bookingId]?.endDate ?? null
            }
          }),
        employeeBookings: Object.values(employeeBookingEntities).filter(
          (emp) => emp.personId == item.personId
        ),
        supervisorInfo: memberEntities[item.personId]
      }
      if (
        !isMemberBusy(
          daysBusy,
          member,
          booking.startDate,
          booking.endDate,
          supervisorBookingEntities,
          bookingEntities
        ) &&
        isMemberBusyAtSupervisor(member, booking.startDate, booking.endDate)
          .length == 0
      ) {
        supervisorBookingDto.push({
          bookingId: booking.id,
          personId: item.personId,
          contractId: item.selectedContract,
          createEmployeeBooking: item.generateEmployeeBooking,
          createdAt: moment().toISOString(),
          status:
            action == BulkAction.INVITE
              ? SupervisorBookingStatus.INVITED
              : SupervisorBookingStatus.ACCEPTED
        })
      } else {
        this.supervisorConflicts.push({
          booking: booking,
          supervisor: member
        })
      }
    })
    return supervisorBookingDto
  }
  public dateValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (moment().isBefore()) {
      return { dateNotValid: true }
    }

    return null
  }
  private isAllowedLinkedProducts(
    booking,
    selectedAllowedLinkedProductIds,
    selectedLinkedProductId,
    selectedBookableProductIds
  ) {
    if (
      !selectedLinkedProductId &&
      selectedAllowedLinkedProductIds.length === 0 &&
      selectedBookableProductIds.length === 0
    ) {
      return false
    }

    return booking.allowedLinkedProducts.includes(selectedLinkedProductId)
  }
  private isBookingProductAllowed(
    booking,
    selectedLinkedProductIds,
    selectedAllowedLinkedProductIds
  ): boolean {
    if (selectedLinkedProductIds) {
      return booking.allowedLinkedProducts.includes(selectedLinkedProductIds)
    }

    return (
      booking.allowedLinkedProducts.filter(
        (allowedProduct) =>
          allowedProduct ===
          selectedAllowedLinkedProductIds?.find(
            (selected) => allowedProduct === selected
          )
      ).length > 0
    )
  }
  public applyYearCalendar(showDisabledDates) {
    this.wantApplyYearMatrix = showDisabledDates
  }
  public onFinishButton() {
    const f = this.form.value

    if (
      f.maxParticipants < this.bookingPartial?.currentParticipantCount &&
      f.maxParticipants != null
    ) {
      this.form.controls.maxParticipants.markAsDirty()
      this.form.controls.maxParticipants.setErrors({ invalid: true })

      this.notificationService.emit(
        'general.maxParticipantsLessThanCurrent',
        'warning'
      )
      return
    }
    if (!moment(f.startDate).isValid()) {
      this.form.controls['startDate'].setErrors({
        dateNotValid: true,
        invalid: true
      })
    }
    if (moment(f.endDate).valueOf() <= moment(f.startDate).valueOf()) {
      this.notificationService.emit('general.incorrectEndDate', 'warning')
      return
    }
    if (!moment(f.endDate).isValid()) {
      this.form.controls['endDate'].setErrors({ dateNotValid: true })
    }

    if (
      this.form.controls['courseId'].value &&
      this.form.controls['productIds'].value.length > 1
    ) {
      this.form.controls['productIds'].setErrors({
        numberOfProductsNotValid: true
      })
      this.translate
        .get('general.errorResources')
        .pipe(take(1))
        .subscribe((msg) => {
          this.notificationService.emit(msg, 'warning')
        })
    }
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsDirty()
      })
      return
    }
    if (!moment(f.endDate).isSame(moment(f.startDate), 'day')) {
      const message = this.translate.instant('bookingModule.wrongMultiDay')
      const shouldProceed = confirm(message)

      if (!shouldProceed) {
        return
      }
    }
    const productIds = this.form.controls['productIds'].value ?? []
    const linkedProductIds = this.form.controls['linkedProductId'].value
      ? [this.form.controls['linkedProductId'].value]
      : []

    const mergedArray = [
      ...new Set([...productIds, ...linkedProductIds])
    ].filter((item) => item !== null && item !== undefined)
    const continueSubmit = () => {
      const bookingPartial = {
        ...f,
        courseId: this.courseId,
        status: f.status !== null ? parseInt(f.status) : null
      }
      this.generalFormSubmitted = true
      this.bookingMultiCreateDto = bookingPartial
      this.bookingPartial = bookingPartial

      if (this.isRepeat) {
        if (this.formRepeatConfig.invalid) {
          Object.keys(this.formRepeatConfig.controls).forEach((key) => {
            this.formRepeatConfig.controls[key].markAsDirty()
          })
          return
        }
        let selectedRepeatOnIds = []
        let timeStampRepeatOn = {}
        if (
          Number(this.formRepeatConfig?.value?.repeatType) ===
          DateRangeRepeatType.Weekly
        ) {
          this.formRepeatConfig.value.repeatOn.forEach((dayControl, i) => {
            const weekDay =
              typeof dayControl.day === 'string'
                ? Number(dayControl.day?.substring(dayControl.day.length - 1))
                : Number(dayControl.day)
            selectedRepeatOnIds.push(weekDay)

            timeStampRepeatOn[weekDay] = {
              startTime: moment(dayControl.startTime).format('HH:mm'),
              endTime: moment(dayControl.endTime).format('HH:mm')
            }
          })
        } else {
          selectedRepeatOnIds = this.formRepeatConfig.value.repeatOn
            .map((checked, i) => (checked ? i + 1 : null))
            .filter((v) => v !== null)
        }

        const dayOfRepeat = this.formRepeatConfig.controls.fromDate.value
          ? moment(this.formRepeatConfig.controls.fromDate.value).format('DD')
          : null

        this.formRepeatConfig.removeControl('repeatOn')
        this.formRepeatConfig.removeControl('repeatOnDay')
        this.formRepeatConfig.addControl('repeatOn', new UntypedFormControl())
        this.formRepeatConfig.addControl(
          'repeatOnDay',
          new UntypedFormControl()
        )
        this.formRepeatConfig.addControl(
          'timeStampRepeatOn',
          new UntypedFormControl()
        )
        this.formRepeatConfig.controls['timeStampRepeatOn'].setValue(
          timeStampRepeatOn
        )
        this.formRepeatConfig.controls.repeatOn.setValue(selectedRepeatOnIds)
        this.formRepeatConfig.controls.repeatOnDay.setValue(dayOfRepeat)
        const bookingStartDate = moment(this.bookingPartial.startDate)

        const bookingEndDate = moment(this.bookingPartial.endDate)

        const serieId = this.bookingPartial.serieId
          ? this.bookingPartial.serieId
          : `${moment().valueOf()}-${uuidv4()}`

        const bookings = getTargetDatesFromConfig(
          this.formRepeatConfig.value
        ).map((date) => {
          return {
            ...this.bookingPartial,
            id: null,
            startDate: Number(
              this.formRepeatConfig.controls.repeatType.value == 2
            )
              ? date.startDate.clone()
              : date.startDate.clone().set({
                  hour: bookingStartDate.get('hours'),
                  minute: bookingStartDate.get('minutes')
                }),
            endDate: Number(
              this.formRepeatConfig.controls.repeatType.value == 2
            )
              ? date.endDate.subtract('minute').clone()
              : date.endDate.clone().set({
                  hour: bookingEndDate.get('hours'),
                  minute: bookingEndDate.get('minutes')
                }),
            serieId
          }
        })

        this.stopLoading = false

        this.onRepeatFormSubmit(bookings)
      } else {
        this.store
          .select(persistentUserRoleSelectors.selectSelectedUserRole)
          .pipe(take(1))
          .subscribe((pUr) => {
            const siteId = pUr && pUr.siteId ? pUr.siteId : 0
            this.stopLoading = false
            this.setBookingPartialsForConfirmation(
              this.bookingMultiCreateDto.productIds.map((productId) => ({
                ...this.bookingMultiCreateDto,
                productId,
                siteId: siteId,
                endDate: this.bookingMultiCreateDto.endDate
              }))
            )
          })
      }
    }

    if (mergedArray?.length > 0) {
      this.store.dispatch(
        productActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              id: { [CondOperator.IN]: mergedArray }
            },
            join: [
              { field: 'parentBookableProducts' },
              { field: 'dependantProducts' }
            ]
          })
        })
      )

      this.store
        .select(productSelectors.selectIsLoading)
        .pipe(
          filter((isLoading) => !isLoading),
          take(1),
          timeout(6000),
          catchError(() => of(false))
        )
        .subscribe(() => continueSubmit())
    } else {
      continueSubmit()
    }
  }

  public onRepeatFormSubmit(bookingPartials: Partial<Booking>[]) {
    const serieId = bookingPartials?.length
      ? `${moment().valueOf()}-${uuidv4()}`
      : null

    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(take(1))
      .subscribe((pUr) => {
        const siteId =
          pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
        this.setBookingPartialsForConfirmation(
          [].concat.apply(
            [],
            [
              ...this.bookingMultiCreateDto.productIds.map((productId) =>
                [
                  ...bookingPartials,
                  ...(!this.isRepeat ? [this.bookingPartial] : [])
                ].map((b) => ({
                  startDate: moment(b.startDate).seconds(0).toISOString(),
                  endDate: moment(b.endDate),

                  status: b.status,
                  courseId: b.courseId,
                  description: b.description,
                  linkedProductId: b.linkedProductId,
                  memo: b.memo,
                  maxParticipants: b.maxParticipants,
                  productId,
                  siteId: siteId,
                  serieId,
                  allowedLinkedProductIds:
                    this.bookingMultiCreateDto.allowedLinkedProductIds
                }))
              )
            ]
          )
        )
        this.isRepeat = false
      })
  }

  public onSelectType(createType: BookingCreationType) {
    this.activeTab = 'generalForm'
    this.selectedBookingCreateType = createType
  }

  private setBookingPartialsForConfirmation(
    bookingsPartials: Partial<Booking>[]
  ) {
    let productEntities: Dictionary<Product>
    this.store
      .select(productSelectors.selectEntities)
      .pipe(take(1))
      .subscribe((pE) => (productEntities = pE))
    this.isRepeat = false
    bookingsPartials = bookingsPartials.sort((a, b) =>
      a.startDate < b.startDate ? -1 : 1
    )

    if (bookingsPartials.filter((b) => Boolean(b))?.length) {
      let startDate = moment(bookingsPartials[0]?.startDate).toISOString()
      let endDate = moment(
        bookingsPartials[bookingsPartials?.length - 1]?.endDate
      ).toISOString()
      const productIds = [
        ...new Set(bookingsPartials.map((it) => it?.productId))
      ]?.filter((ite) => Boolean(ite))

      bookingsPartials.forEach((item, idx) => {
        const allProductIds = new Set([
          item.productId,
          ...(productEntities[item.productId]?.dependantProducts || [])
        ])
        allProductIds?.forEach((pId) => {
          if (!productIds.includes(pId)) {
            productIds.push(pId)
          }
        })
      })

      this.actions$
        .pipe(
          ofType(bookingActions.upsertMany),
          take(1),
          timeout(6000),
          catchError((error) => of(null))
        )
        .subscribe((action) => {
          let intersectingBookings = []
          if (action && action.entities) intersectingBookings = action.entities

          this.reviewIntersectingBookings(
            bookingsPartials,
            intersectingBookings
          )
        })

      // fetch bookings that could possibly intersect with the creatable bookings
      this.store.dispatch(
        bookingActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              productId: { [CondOperator.IN]: productIds },
              startDate: {
                [CondOperator.BETWEEN]: [
                  moment(startDate)
                    .startOf('day')
                    .subtract(2, 'hours')
                    .toISOString(),
                  moment(endDate).endOf('day').add(2, 'hours').toISOString()
                ]
              },
              endDate: {
                [CondOperator.BETWEEN]: [
                  moment(startDate)
                    .startOf('day')
                    .subtract(2, 'hours')
                    .toISOString(),
                  moment(endDate).endOf('day').add(2, 'hours').toISOString()
                ]
              }
            }
          })
        })
      )
    }
    return
  }
  private getAllDependants(
    bookingsToCreate: Partial<Booking>[],
    productEntities: Dictionary<Product>
  ) {
    if (!bookingsToCreate || !productEntities) return []

    const dependantProductConflict = []

    bookingsToCreate.forEach((booking, idx) => {
      const dependantProductIds: number[] =
        productEntities[booking.productId]?.dependantProducts || []
      const hasDependantProductConflict = bookingsToCreate.some(
        (otherBooking, otherIdx) =>
          otherIdx !== idx &&
          dependantProductIds.includes(otherBooking.productId) &&
          moment(booking.startDate).isBefore(moment(otherBooking.endDate)) &&
          moment(booking.endDate).isAfter(moment(otherBooking.startDate))
      )

      if (hasDependantProductConflict) {
        dependantProductConflict.push({ ...booking, idx })
      }
    })

    return dependantProductConflict
  }
  private reviewIntersectingBookings(
    bookingsPartials: Partial<Booking>[],
    intersectingBookings: any
  ) {
    console.log('User now in reviewIntersectingBookings')
    let productEntities: Dictionary<Product>
    this.productEntities$
      .pipe(take(1))
      .subscribe((pE) => (productEntities = pE))
    let bookingsWIssues = []

    let intersecBookings: Booking[] = JSON.parse(
      JSON.stringify(intersectingBookings)
    )
    let auxBookingsPartials: Partial<Booking>[] = JSON.parse(
      JSON.stringify(bookingsPartials)
    )
    const dependantProductConflict = this.getAllDependants(
      auxBookingsPartials,
      productEntities
    )

    if (this.disabledDates?.length > 0) {
      let auxDisabledDates = this.disabledDatesToApply.map((date) =>
        moment(date).format('YYYY-MM-DD')
      )

      auxBookingsPartials.forEach((booking, idx) => {
        const dependantProductIds: number[] =
          productEntities[booking.productId]?.dependantProducts || []
        const sameProductConflict = intersecBookings.find((event) => {
          return (
            moment(booking.startDate).isBefore(moment(event.endDate)) &&
            moment(booking.endDate).isAfter(moment(event.startDate)) &&
            event.productId == booking.productId
          )
        })
        const dependantProductConflictOnExistingBooking =
          intersecBookings.find((event) => {
            return (
              moment(booking.startDate).isBefore(moment(event.endDate)) &&
              moment(booking.endDate).isAfter(moment(event.startDate)) &&
              dependantProductIds.includes(event.productId)
            )
          })

        if (
          auxDisabledDates.includes(
            moment(booking.startDate).format('YYYY-MM-DD')
          ) &&
          this.wantApplyYearMatrix
        ) {
          bookingsWIssues.push(bookingsPartials[idx])
          delete bookingsPartials[idx]
        } else if (
          sameProductConflict ||
          dependantProductConflictOnExistingBooking
        ) {
          bookingsWIssues.push({
            ...bookingsPartials[idx],
            intersectingBooking: sameProductConflict?.id,
            dependantProductIssue: Boolean(
              dependantProductConflictOnExistingBooking
            )
          })
          delete bookingsPartials[idx]
        } else if (dependantProductConflict.find((it) => it.idx == idx)) {
          bookingsWIssues.push({
            ...bookingsPartials[idx],
            yearCalendarIssue: false,
            markYearCalendaIssues: false,
            dependantProductIssue: true
          })
          delete bookingsPartials[idx]
        }
      })
      bookingsPartials = bookingsPartials.filter((b) => Boolean(b))
    } else {
      auxBookingsPartials.forEach((booking, idx) => {
        const endDate = moment(booking.endDate).subtract(
          this.roundMinutes.transform(
            moment(booking.endDate).toDate().getMinutes()
          ),
          'minutes'
        )
        const dependantProductIds: number[] =
          productEntities[booking.productId]?.dependantProducts || []
        const sameProductConflict = intersecBookings.find(
          (bk) =>
            moment(bk.startDate).isSameOrBefore(moment(endDate)) &&
            moment(bk.endDate).isSameOrAfter(booking.startDate) &&
            bk.productId == booking.productId
        )
        const dependantProductConflictOnExistingBooking =
          intersecBookings.find(
            (bk) =>
              moment(bk.startDate).isSameOrBefore(moment(endDate)) &&
              moment(bk.endDate).isSameOrAfter(booking.startDate) &&
              dependantProductIds.includes(bk.productId)
          )
        if (sameProductConflict || dependantProductConflictOnExistingBooking) {
          bookingsWIssues.push({
            ...bookingsPartials[idx],
            intersectingBooking: sameProductConflict?.id,
            dependantProductIssue: Boolean(
              dependantProductConflictOnExistingBooking
            )
          })
          delete bookingsPartials[idx]
        } else if (dependantProductConflict.find((it) => it.idx == idx)) {
          bookingsWIssues.push({
            ...bookingsPartials[idx],
            yearCalendarIssue: false,
            markYearCalendaIssues: false,
            dependantProductIssue: true
          })
          delete bookingsPartials[idx]
        }
      })
      bookingsPartials = bookingsPartials.filter((b) => Boolean(b))
    }

    if (bookingsWIssues?.length) {
      bookingsWIssues = this.enrichBookings(
        bookingsWIssues,
        productEntities,
        Math.floor(Math.random() * 500000),
        true
      )
    }
    if (bookingsPartials?.length) {
      bookingsPartials = this.enrichBookings(
        JSON.parse(JSON.stringify(bookingsPartials)),
        productEntities,
        0
      )
    }
    const modalRef = this.modalService.show(
      BookingSeriesModalComponent,

      {
        initialState: {
          arrayBookingsWOIssues: bookingsPartials ?? [],
          arrayBookingsWIssues: bookingsWIssues ?? [],
          showFormValue: false,
          creatingBooking: true,
          buttonSaveText: 'bookingModule.createBookings',
          showCancelButton: true,
          showBulkActionTitle: false,
          showTargetDates: false,
          issueBulkActions: [
            BulkAction.KEEP_ORIGINAL_TIME,
            BulkAction.OVERRULE_CALENDAR,
            BulkAction.DELETE
          ],
          bulkActionsCanBeDisabled: [
            BulkAction.KEEP_ORIGINAL_TIME,
            BulkAction.OVERRULE_CALENDAR
          ]
        },
        class: 'modal-xl modal-dialog-centered mod-4',
        backdrop: 'static'
      }
    )
    modalRef.onHide.pipe(take(1)).subscribe((event) => {
      console.log('On hide reviewIntersectingBookings')
      if (modalRef.content.clickCancel) {
        this.assignSupervisor = false
        this.clickOnCancelButton()
        this.wantApplyYearMatrix = false
        this.isRepeat = false
        return
      }
      this.actions$
        .pipe(
          ofType(bookingActions.upsertMany, bookingActions.createManyFailed),
          take(1),
          timeout(25000),
          catchError(() => {
            this.stopLoading = true
            return of(null)
          })
        )
        .subscribe((action) => {
          console.log('On hide reviewIntersectingBookings got created bookings')
          if (!action) {
            return
          }
          if (action) {
            this.stopLoading = true
            if ('total' in action && action?.total !== undefined) {
              if (this.createSupervisorBooking) {
                this.store
                  .select(supervisorBookingSelectors.selectActionFinished)
                  .pipe(
                    first(
                      (actItem) =>
                        actItem !== null &&
                        actItem.action ==
                          supervisorBookingActions.createMany.type
                    ),
                    timeout(10000)
                  )
                  .subscribe(() => {
                    this.checkTypeAndContinue(action)
                    this.assignSupervisor = false
                  })
              } else {
                this.checkTypeAndContinue(action)
                this.assignSupervisor = false
              }
            } else if ('total' in action && action?.total !== undefined) {
              this.bsModalRef.hide()
              this.showReviewBookingModal(action)
            }
          }
        })
      bookingsPartials = []
      modalRef.content.arrayBookingsWOIssues.map((item) => {
        delete item.id
        delete item.startTargetDate
        delete item.endTargetDate
        delete item.activity
        delete item.resource
        bookingsPartials.push(item)
      })
      console.log(
        `Total Booking without issues to create:${bookingsPartials?.length} `
      )
      if (bookingsPartials.length < 1) {
        return
      }
      console.log(`Will post bookings to api`)
      this.store.dispatch(
        bookingActions.createManyWithOneMinuteLess({
          entities: bookingsPartials.map((b) => ({
            ...b,
            startDate: moment(b.startDate).seconds(0),
            endDate: moment(b.endDate).seconds(0)
          }))
        })
      )
      if (this.createBookingFromSchedule || this.courseId) {
        this.bsModalRef.hide()
      }
      this.actions$
        .pipe(
          ofType(
            bookingActions.createManySuccess,
            bookingActions.createManyFailed
          ),
          take(1),
          timeout(25000),
          catchError(() => {
            this.stopLoading = true
            return of(null)
          })
        )
        .subscribe((action) => {
          this.createdBookings = []
          this.showCreatedBookingsModal = false
          if (
            !action ||
            action.type === bookingActions.createManyFailed().type
          ) {
            return
          }

          console.log('Bookings created successfully', action)
          if (this.courseId) {
            this.router.navigate(['/courses/', this.courseId, 'bookings'])
          } else {
            this.showCreatedBookingsModal = true
            this.createdBookings = action?.entities ?? []
          }
        })
    })
  }
  private enrichBookings(
    bookings: RichedBooking[],
    productEntities: Dictionary<Product>,
    startId = 0,
    withIssues = false
  ): RichedBooking[] {
    if (!bookings?.length) return []

    let id = startId

    return bookings.map((item: RichedBooking) => {
      const richedBooking: RichedBooking = {
        ...item,
        id: ++id,
        startTargetDate: item.startDate,
        endTargetDate: item.endDate,
        activity: item.linkedProductId
          ? productEntities[item.linkedProductId]?.description
          : null,
        resource: item.productId
          ? productEntities[item.productId]?.description
          : null,
        ...(withIssues && {
          yearCalendarIssue:
            item?.intersectingBooking || item.dependantProductIssue
              ? false
              : true
        })
      }

      return richedBooking
    })
  }

  public onClickRow(booking: Booking) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/bookings/${booking.id}`])
    )
    window.open(url, '_blank')
  }
  private createManyAllowedLinkedProductLinks(action) {
    let allowedLinkedProductIds = []
    allowedLinkedProductIds = this.selectedAllowedLinkedProductIds
    if (allowedLinkedProductIds?.length > 0) {
      console.log(
        `create allowedLinkedProductLinks: ${allowedLinkedProductIds.length}`
      )
      this.actions$
        .pipe(ofType(bookingActions.upsertMany), take(1), timeout(5000))
        .subscribe((action) => {
          this.resetFormAndRouter()
        })
      this.store.dispatch(
        bookingActions.createManyAllowedLinkedProductLinks({
          entities: action.entities.reduce(
            (result, b) => [
              ...result,
              ...allowedLinkedProductIds.map((productId) => ({
                bookingId: b.id,
                productId
              }))
            ],
            []
          )
        })
      )
    } else {
      this.notificationService.emit(
        'alerts.noAllowedLinkedProductIdsFound',
        'warning'
      )
    }
  }
  private showReviewBookingModal(action) {
    const modalRef = this.modalService.show(
      BookingReviewTableComponent,

      {
        initialState: {
          tableData: action.entities ?? [],
          isModal: true
        },
        class: 'modal-xl modal-dialog-centered modal-dialog-scrollable mod-5',
        backdrop: 'static'
      }
    )
    modalRef.onHide.pipe(take(1)).subscribe((event) => {
      if (modalRef.content.onSaveClicked) {
        this.assignSupervisor = false
        let totalDeselected = 0
        this.store
          .select(bookingSelectors.selectEntities)
          .pipe(take(1))
          .subscribe((bookEntities) => {
            modalRef.content?.checkedIds?.forEach((selected, bookingId) => {
              if (!selected) {
                totalDeselected++
                this.store.dispatch(
                  bookingActions.updateOneById({
                    id: bookingId,
                    params: {
                      courseId: null,
                      endDate: bookEntities[bookingId].endDate,
                      startDate: bookEntities[bookingId].startDate
                    }
                  })
                )
                this.actions$
                  .pipe(ofType(bookingActions.upsertOne), take(1))
                  .subscribe((action) => totalDeselected--)
              }
            })
            if (this.createSupervisorBooking) {
              this.store
                .select(supervisorBookingSelectors.selectActionFinished)
                .pipe(
                  first(
                    (actItem) =>
                      actItem !== null &&
                      actItem.action == supervisorBookingActions.createMany.type
                  ),
                  timeout(10000)
                )
                .subscribe((action) => {
                  this.checkTypeAndContinue(action)
                })
            } else {
              this.checkTypeAndContinue(action)
            }
          })
      }
    })
  }
  public checkTypeAndContinue(action) {
    if (
      [BookingCreationType.MULTI_ACTIVITY].includes(
        this.selectedBookingCreateType
      )
    ) {
      this.createManyAllowedLinkedProductLinks(action)
    } else {
      this.resetFormAndRouter()
    }
  }
  public resetFormAndRouter() {
    this.notificationService.emit('alerts.success', 'success')
    this.bookingPartial = {}
    if (!this.createBookingFromSchedule && !this.courseId) {
      this.activeTab = 'bookingType'
      this.router.navigate([`/bookings/create`], {
        queryParams: { activeTab: 'bookingType' }
      })
    }

    this.formRepeatConfig.reset()
    this.form.reset()
  }

  public onChangeDates(event: { startDate: Date; endDate: Date }) {
    this.event$.next({ startDate: event.startDate, endDate: event.endDate })
  }
  public onClickEvent(event) {
    if (event.params?.booking && event.params?.booking?.startDate) {
      this.selectedDate$.next({
        time: moment(event.params.booking.startDate),
        isFromCreate: true
      })
    }
  }
  public onClickDate(dt: moment.Moment) {
    this.selectedDate$.next({ time: moment(dt), isFromCreate: true })
  }

  onValueChangesEvent(event) {
    this.selectedAllowedLinkedProductIds = event.allowedLinkedProductIds ?? []
    this.form.patchValue(event)
    this.selectedBookableProductIds$.next(event.productIds)
    this.selectedLinkedProductId$.next(event.linkedProductId)
    this.selectedAllowedLinkedProductIds$.next(event.allowedLinkedProductIds)
  }

  public onClickBackButton() {
    this.activeTab = 'bookingType'
    this.router.navigate([`/bookings/create`], {
      queryParams: { activeTab: 'bookingType' }
    })
  }
  public disableComponent() {
    return (
      this.form.valid &&
      (moment(this.form.value.endDate).isValid() ||
        moment(this.form.value.startDate).isValid())
    )
  }
  public setSelectedFormInBooKingFormRepeat() {
    return this.form.controls.startDate.value &&
      moment(this.form.controls.startDate.value).isValid()
      ? this.form
      : null
  }
  public openModalRepeatbookings(repeat) {
    this.showRepeatForm = repeat
    this.isRepeat = repeat

    if (!this.isRepeat) {
      this.clickOnCancelButton()
    }
  }
  public clickOnCancelButton() {
    this.disabledDatesToApply = JSON.parse(JSON.stringify(this.disabledDates))
    this.isRepeat = false
    this.showRepeatForm = false
    const repeatOn = this.formRepeatConfig?.get('repeatOn')

    if (repeatOn instanceof UntypedFormArray) {
      repeatOn.clear()
    } else if (repeatOn instanceof UntypedFormControl) {
      repeatOn.setValue(null)
    }
    this.formRepeatConfig?.patchValue({
      repeatType: DateRangeRepeatType.Weekly,
      repeatEvery: null,
      repeatOnDay: null,
      fromDate: null,
      tillDate: null
    })
    this.resetRepeatForm$.next(true)
  }
  public clickOnSaveButton({
    disabledDates,
    wantApplyYearMatrix
  }: {
    disabledDates: Date[]
    wantApplyYearMatrix: boolean
  }) {
    this.disabledDatesToApply = [...disabledDates]
    this.wantApplyYearMatrix = wantApplyYearMatrix
    this.notificationService.emit('alerts.success', 'success')
    this.showRepeatForm = false
    this.isRepeat = true
  }
  onDateAdjustment(event: boolean) {
    if (
      event &&
      (this.isRepeat ||
        this.assignSupervisor ||
        this.supervisorAssign.arraySupervisor?.length > 0)
    ) {
      this.resetErasableConfigurations()
    }
  }

  /**
   * @description Resets configurations that should be cleared when the main booking dates are changed
   * such as repeat settings and supervisor assignments.
   * @satisfies Clears all repeat configs
   * @satisfies Clears all supervisor bookings
   */
  private resetErasableConfigurations() {
    // Clear repeat configurations
    const repeatOn = this.formRepeatConfig?.get('repeatOn') as UntypedFormArray
    repeatOn.clear()

    //Update to the new selected days with default weekly type
    this.formRepeatConfig?.patchValue({
      repeatType: DateRangeRepeatType.Weekly,
      repeatEvery: null,
      repeatOnDay: null,
      fromDate: this.form.controls.startDate.value,
      tillDate: this.form.controls.endDate.value
    })

    this.isRepeat = false
    this.showRepeatForm = false
    this.resetRepeatForm$.next(true)

    // Clear supervisor booking configurations
    this.assignSupervisor = false
    this.createSupervisorBooking = false
    this.supervisorAssign = {
      dateRange: null,
      action: null,
      startDate: null,
      endDate: null,
      arraySupervisor: []
    }
    this.supervisorConflicts = []
    this.resetSupervisorBookingsData$.next(true)

    this.notificationService.emit(
      'bookingModule.resetSettingsAfterDateAdjustment',
      'info'
    )
  }
  ngOnDestroy() {
    this.subscriptions.map((s) => s.unsubscribe())
  }
}
